// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"860":"188a3063","895":"247dbe64","940":"baaf7682"}[chunkId] + ".css";
};